module.exports = __webpack_public_path__ + "cf1c0b75107bb54486b1c6b3cdabe5f6.jpg";